<template>
  <div id="home">
    <div class="banner_home">
      <el-carousel :interval="3000" height="490px" class="banner_lb">
        <el-carousel-item v-for="(item,index) in banner" :key="index">
          <div class="img_z">
            <div class="banner_p">
              <p style="font-size:38px;font-weight:500;">帮助企业数字化转型升级</p>
              <p>用数据智能为您的业务加速</p>
              <p class="apply" @click="apply()">
                <span @click="helseshi = true">申请使用</span>
                <img src="../assets/home/index_btn_more.png" alt class="icon_right" />
              </p>
            </div>
            <img :src="imgPath + item.picture_address" alt class="banner_img" />
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>
    <div class="content">
      <div class="content-one">
        <div class="content-one_con">
          <p class="one_p">AI拓客系统 全行业全场景的线上解决方案</p>
          <ul class="one_li">
            <li>
              <div class="one_div">
                <img src="../assets/home/index-a_icon_A01.png" alt />
                <p class="time">短时间快速上线</p>
                <p class="line"></p>
                <p class="details">百人研发团队历时两年研发打磨的标准化应用产品</p>
              </div>
            </li>
            <li></li>
            <li>
              <div class="one_div">
                <img src="../assets/home/index-a_icon_A02.png" alt />
                <p class="time">裂变获客 精准寻客</p>
                <p class="line"></p>
                <p class="details">扩大商家私域流量池，增加交易量，提升营业额</p>
              </div>
            </li>
            <li></li>
            <li>
              <div class="one_div">
                <img src="../assets/home/index-a_icon_A03.png" alt />
                <p class="time">打造线上品牌</p>
                <p class="line"></p>
                <p class="details">线上发展，全面提升品牌知名度</p>
              </div>
            </li>
            <li></li>
            <li>
              <div class="one_div">
                <img src="../assets/home/index-a_icon_A04.png" alt />
                <p class="time">扩大销售渠道</p>
                <p class="line"></p>
                <p class="details">线上商城，再也无须担忧不可抗力的发生（如新冠疫情）</p>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <div class="content-two">
        <img src="../assets/home/index-b_bg.png" class="two_img" />
        <div class="content-two_con">
          <p class="one_p" style="color:#fff;">智能推广实现销售增长 技术赋能打造全民营销</p>
          <ul class="two_li">
            <li>
              <div class="two_div">
                <img src="../assets/home/index-b_icon_value01.png" alt />
                <p class="money">万元</p>
                <p class="xiaoes">提升销售额</p>
              </div>
            </li>
            <li>
              <div class="two_div">
                <img src="../assets/home/index-b_icon_value02.png" alt />
                <p class="money">万元</p>
                <p class="xiaoes">提升销售额</p>
              </div>
            </li>
            <li>
              <div class="two_div">
                <img src="../assets/home/index-b_icon_value03.png" alt />
                <p class="money">万元</p>
                <p class="xiaoes">提升销售额</p>
              </div>
            </li>
            <li>
              <div class="two_div">
                <img src="../assets/home/index-b_icon_value04.png" alt />
                <p class="money">万元</p>
                <p class="xiaoes">提升销售额</p>
              </div>
            </li>
          </ul>
          <div class="two_apply"  @click="helseshi = true">
            <p>申请使用</p>
          </div>
        </div>
      </div>
      <div class="content-three">
        <div class="content-three_con">
          <p class="one_p1">我们为企业提供全流程智能化销售解决方案</p>
          <p class="one_p2">利用AI大数据，实现企业营销全流程的数字化、智能化</p>
          <img src="../assets/home/index-c_bg02.png" alt />
        </div>
      </div>
      <div class="content-four_home">
        <img src="../assets/home/index_bg03.png" alt class="four_img" />
        <div class="content-four_con_home">
          <p class="one_p">支持三大小程序平台</p>
          <div class="four_li_home">
            <ul>
              <li @click="lever()">
                <img src="../assets/home/index-d_icon_wx_nor.png" class="wx" alt />
                <p>微信小程序</p>
                <img src="../assets/home/index-d_icon_sign.png" v-show="show" alt />
              </li>
              <li @click="lever1()">
                <img src="../assets/home/index-d_icon_dy_nor.png" class="dy" alt />
                <p>抖音小程序</p>
                <img src="../assets/home/index-d_icon_sign.png" v-show="show1" alt />
              </li>
              <li @click="lever2()">
                <img src="../assets/home/index-d_icon_tt_nor.png" class="tt" alt />
                <p>头条小程序</p>
                <img src="../assets/home/index-d_icon_sign.png" v-show="show2" alt />
              </li>
            </ul>
          </div>
          <div class="four_botm" v-show="wx">
            <ul>
              <li>
                <div class="four_div">
                  <img src="../assets/home/index-d_icon_wx01.png" alt />
                  <p class="times">使用门槛更低，更便捷</p>
                  <p class="line"></p>
                  <p class="app">无需下载APP，在微信上通过关键词即可快速搜索到商家品牌</p>
                </div>
              </li>
              <li>
                <div class="four_div">
                  <img src="../assets/home/index-d_icon_wx02.png" alt />
                  <p class="times">公众号信息互通</p>
                  <p class="line"></p>
                  <p class="app">可以绑定在已有的微信公众号自定义菜单内，动态信息实时推送</p>
                </div>
              </li>
              <li>
                <div class="four_div">
                  <img src="../assets/home/index-d_icon_wx03.png" alt />
                  <p class="times">抢占先机，促进销售转化</p>
                  <p class="line"></p>
                  <p class="app">微信搜一搜功能即将上线“服务搜索”功能，帮助品牌搜索关键词</p>
                </div>
              </li>
            </ul>
          </div>
          <div class="four_botm" v-show="dy">
            <ul>
              <li>
                <div class="four_div">
                  <img src="../assets/home/index-d_icon_dyo1.png" alt />
                  <p class="times">短视频带品牌</p>
                  <p class="line"></p>
                  <p class="app">小程序可在短视频下方展示，抖音帮你推荐给更多人</p>
                </div>
              </li>
              <li>
                <div class="four_div">
                  <img src="../assets/home/index-d_icon_dy02.png" alt />
                  <p class="times">多种营销工具</p>
                  <p class="line"></p>
                  <p class="app">优惠券、拼团、卡卷核销、预约、供需发布，助企业拉新、转化、复购</p>
                </div>
              </li>
              <li>
                <div class="four_div">
                  <img src="../assets/home/index-d_icon_dy03.png" alt />
                  <p class="times">变现渠道搭建</p>
                  <p class="line"></p>
                  <p class="app">降低客户搭建视频电商平台的成本，缩短卖货账期，助力企业营销变现</p>
                </div>
              </li>
            </ul>
          </div>
          <div class="four_botm" v-show="tt">
            <ul>
              <li>
                <div class="four_div">
                  <img src="../assets/home/index-d_icon_tt01.png" alt />
                  <p class="times">大流量入口</p>
                  <p class="line"></p>
                  <p class="app">多个小程序入口，留存历史用户，实时互动新鲜到达，传播更广泛</p>
                </div>
              </li>
              <li>
                <div class="four_div">
                  <img src="../assets/home/index-d_icon_tt02.png" alt />
                  <p class="times">内容匹配推荐分发</p>
                  <p class="line"></p>
                  <p class="app">内容链接服务，让服务找到用户</p>
                </div>
              </li>
              <li>
                <div class="four_div">
                  <img src="../assets/home/index-d_icon_tt03.png" alt />
                  <p class="times">广告投放</p>
                  <p class="line"></p>
                  <p class="app">精准定位用户群，Feed流广告投放品牌/竞价，提升广告转化率</p>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="content-five">
        <div class="content-five_con">
          <p class="one_p">你的同行都选择今云AI拓客</p>
          <div class="five_li">
            <ul>
              <li>
                <img src="../assets/home/index-e_icon_A01.png" alt />
                <p>政府招商</p>
              </li>
              <li>
                <img src="../assets/home/index-e_icon_A02.png" alt />
                <p>农产品销售</p>
              </li>
              <li>
                <img src="../assets/home/index-e_icon_A03.png" alt />
                <p>全行业微商城</p>
              </li>
              <li>
                <img src="../assets/home/index-e_icon_A04.png" alt />
                <p>店铺零售</p>
              </li>
              <li>
                <img src="../assets/home/index-e_icon_A05.png" alt />
                <p>美业</p>
              </li>
              <li>
                <img src="../assets/home/index-e_icon_A06.png" alt />
                <p>教育</p>
              </li>
              <li>
                <img src="../assets/home/index-e_icon_A07.png" alt />
                <p>金融</p>
              </li>
            </ul>
            <div class="five_right">
              <img src="../assets/home/index-e_icon_A08.png" alt />
            </div>
          </div>
          <div class="five_botm">
            <ul>
              <li v-for="(item,index) in lists" :key="index">
                <div class="tg_app_card">
                  <div class="show tg_app_face">
                    <img :src="imgPath + item.LOGO" alt />
                    <p class="xun">{{item.brand_name}}</p>
                    <p class="xun_deas" v-html="item.content">{{item.content}}</p>
                  </div>
                  <div class="shows tg_app_face">
                    <img :src="imgPath + item.code" alt />
                    <p class="xun">{{item.brand_name}}</p>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <el-dialog :visible.sync="helseshi" width="584px">
      <div class="hesll" style="margin-bottom:20px;" >
        <p>现在注册，免费体验</p>
        <p></p>
      </div>
      <el-form
        :inline="true"
        :model="formregister"
        :rules="rulesregister"
        ref="formregister"
        class="demo-form-inline"
        style="margin-left:100px;margin-right: 100px"
        label-width="120px"
        hide-required-asterisk
        close-on-press-escape="false"
        close-on-click-modal="false"
      >
        <div class="input">
          <el-form-item label="登录账号" style="margin-left:10px" class="wh" prop="account">

            <el-input class="minaword" type="text" placeholder="请输入账号（同时作为小程序名称）" autocomplete="off" v-model="formregister.account" />

          </el-form-item>

        </div>
        <div class="new_wied"> 登录账号=小程序名称</div>
        <div class="input">
          <el-form-item label="密码" style="margin-left:10px " class="wh" prop="password" >
            <el-input class="minaword" show-password placeholder="请输入登录密码" v-model="formregister.password"></el-input>
          </el-form-item>
        </div>
        <div class="input">
          <el-form-item label="确认密码" style="margin-left:10px " class="wh" prop="agenpassword">
            <el-input class="minaword" show-password placeholder="请再次输入登录密码" v-model="formregister.agenpassword"></el-input>
          </el-form-item>
        </div>
        <div class="input">
          <el-form-item label="手机号" style="margin-left:10px" class="wh" prop="phone" >
            <el-input class="minaword" type="text" placeholder="请输入您的手机号" v-model="formregister.phone" autocomplete="off"/>
          </el-form-item>
        </div>
        <div class="input">
          <el-form-item label="推荐人手机号" style="margin-left:10px" class="wh" >
            <el-input class="minaword" type="text" placeholder="如有，则填写" v-model="formregister.agent_phone" autocomplete="off" />
          </el-form-item>
        </div>
        <el-form-item>
          <el-button  v-if="fenyed ===1" type="primary" class="buttons" @click="registerd(formregister)">注册并登录</el-button>
          <div class="fle_butern">
            <div></div>
            <div>已有账号，<el-button class="fle-butt" @click="lodnin">直接登录</el-button></div>
          </div>
        </el-form-item>
      </el-form>
      <div class="floords">
        <p>如有疑问，可拨打咨询热线： 022-8821-9596</p>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getrotation, getcase_management } from "@/config/api";
import { getintention_customer_add_sub } from "@/config/api";
import {index_freeTrial } from "@/csconfig/api";
export default {
  data() {
    var validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'));
      } else {
        if (this.formregister.agenpassword !== '') {
          this.$refs.formregister.validateField('agenpassword');
        }
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'));
      } else if (value !== this.formregister.password) {
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    };
    var valiphone = (rule, value, callback) =>{
      if (value === '') {
        callback(new Error('手机号不为空'));
      } else if(!(/^1[3456789]\d{9}$/.test(value))){
        callback(new Error("手机号格式错误"))
      }else{
        callback();
      }
    };
    var valiagentphone = (rule, value, callback) =>{
      if (value === '') {
        callback();
      } else if(!(/^1[3456789]\d{9}$/.test(value))){
        callback(new Error("手机号格式错误"))
      }else{
        callback();
      }
    };
    this.$emit("footer", true); //是否显示头部
    return {
      imgPath: "http://gwapi.jinyunai.com/",
      show: true,
      show2: false,
      show1: false,
      wx: true,
      dy: false,
      tt: false,
      banner: [],
      lists: [],
      helseshi: false,
      formInline: {
        name: "",
        phone: "",
        application_area: ""
      },
      options: [],
      defaultParams: {
        label: "name",
        value: "name",
        children: "children"
      },
      formregister: {
        phone: "",
        password:'',
        agenpassword:'',
        account:'',
        agent_phone:'',
      },
      rulesregister: {
        phone: [{ validator: valiphone, trigger: 'blur' },],
        password: [ { validator: validatePass, trigger: 'blur' },],
        agenpassword: [{ validator: validatePass2, trigger: 'blur' },],
        account: [{ required: true,message: '请输入公司名称', trigger: 'blur' },],
        agent_phone:[{ validator: valiagentphone, trigger: 'blur' }]
      },
      zhucdengl:false,
      wangj:true,
      fenyed:1,
      urld:'https://card.sqifu.com/#/login',
    };
  },
  methods: {
    apply() {
      console.log(111)
      this.helseshi = true;
    },
    lever() {
      this.show = true;
      this.wx = true;
      this.show1 = false;
      this.tt = false;
      this.show2 = false;
      this.dy = false;
    },
    lever1() {
      this.show1 = true;
      this.dy = true;
      this.show = false;
      this.wx = false;
      this.show2 = false;
      this.tt = false;
    },
    lever2() {
      this.show2 = true;
      this.tt = true;
      this.show = false;
      this.wx = false;
      this.show1 = false;
      this.dy = false;
    },
    produ() {
      this.$router.push({
        path: "/product"
      });
    },
    geilubo() {
      getrotation().then(res => {
        this.banner = res.data.content;
      });
    },
    getlista() {
      getcase_management({ page: 1, page_size: 8 }).then(res => {
        this.lists = res.data.content;
      });
    },
    addsup() {
      this.formInline.application_area = this.formInline.application_area.toString();
      getintention_customer_add_sub(this.formInline).then(res => {
        if (res.data.code == 20000) {
          this.$message({
            message: "申请成功",
            type: "success"
          });
          this.helseshi = false;
        }
      });
    },
    //优质服务商
    getManagement() {
      this.$http(
        "https://www.newcoc.cn/WebProgram/WebApi/getRegionList",
        "post"
      ).then(res => {
        this.options = res.data.data;
      });
    },
    handleChange(value) {
      let labels = this.$refs["cascaderAddr"].currentLables;
    },
    registerd (formregister) {
      var that = this
      var formregister = that.formregister
      var urld = this.urld
      console.log(formregister)
      this.$refs.formregister.validate((valid) => {
        if (valid) {
          index_freeTrial(formregister).then(res =>{
            if (res.data.code == 200) {
              this.$message({
                message: "申请成功",
                type: "success"
              });
              this.helseshi = false;
              urld = urld + '?account=' + formregister.account + '&password=' + formregister.password
              window.location.href = urld
            }
            if(res.data.code ===400){
              this.$message({
                message: res.data.error,
                type: 'error'
              });
            }
          })
        } else {
          console.log('error submit!!');
          return false;
        }
      });

    },
    lodnin () {
      this.zhucdengl = false
      this.wangj = true
      this.fenyed = 1
      window.location.href = this.urld
    }
  },
  created() {
    this.geilubo();
    this.getlista();
    this.getManagement();
  }
};
</script>

<style scoped>
@import "../components/style.css";
@import "../components/style1.css";
* {
  margin: 0;
  padding: 0;
  list-style: none;
}

#home {
  width: 100%;
  position: relative;
  overflow: hidden;
}

.top {
  width: 100%;
  background: #2b2f33;
  position: fixed;
  z-index: 99;
}

.top_one {
  width: 1200px;
  margin: 0 auto;
}

.img {
  width: 200px;
  height: 40px;
  padding: 10px 57px 15px 0;
  float: left;
}

.top_li li {
  float: left;
  line-height: 65px;
  color: #fff;
  margin-right: 43px;
  cursor: pointer;
}

.top_li li:hover {
  color: #337eff;
}

.top_right {
  float: right;
  line-height: 65px;
}

.button {
  width: 90px;
  height: 33px;
  line-height: 0;
  padding: 0;
}

.bottons {
  background-color: transparent;
  color: #409eff;
  border: 1px solid #409eff;
}

.bottons:hover {
  background-color: #409eff;
}

.add {
  margin-left: 5px;
}

.banner_home {
  width: 100%;
  margin-top: 65px;
}

.banner_lb {
  width: 100%;
  /* z-index: -1; */
}

.banner_img {
  width: 100%;
  height: 490px;
}

.img_z {
  width: 100%;
  position: relative;
  z-index: 1;
}

.banner_p {
  width: 1200px;
  position: absolute;
  left: 50%;
  margin-left: -600px;
  top: 130px;
  z-index: 1;
}

.banner_p p {
  color: #fff;
}

.banner_p p:nth-child(2) {
  font-size: 20px;
  margin: 50px 0 0 0;
}

.banner_p p:nth-child(3) {
  width: 170px;
  height: 40px;
  background: #337eff;
  border-radius: 4px;
  margin: 70px 0 0 0;
  z-index: 99;
}

.apply {
  line-height: 40px;
  cursor: pointer;
}

.apply span {
  float: left;
  margin: 0 2px 0 50px;
}

.banner_p p:nth-child(3) img {
  float: left;
  margin-top: 11px;
}

.content {
  width: 100%;
}

.content-one {
  width: 100%;
  height: 525px;
  overflow: hidden;
}

.content-one_con {
  width: 1200px;
  margin: 0 auto;
}

.one_p {
  text-align: center;
  font-size: 34px;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  margin: 100px 0 78px 0;
}

.floor_onep {
  text-align: center;
  font-size: 34px;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  margin: 60px 0 40px 0;
}

.one_p1 {
  text-align: center;
  font-size: 34px;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  margin: 100px 0 19px 0;
}

.one_p2 {
  text-align: center;
  font-size: 20px;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
  margin: 0px 0 69px 0;
}

.one_li li {
  width: 247px;
  text-align: center;
}

.one_li img {
  margin-bottom: 20px;
}

.one_li li {
  float: left;
}

.one_li li:nth-child(2),
.one_li li:nth-child(4),
.one_li li:nth-child(6) {
  width: 1px;
  height: 162px;
  background: rgba(241, 244, 248, 1);
  margin: 26px 30px;
}

.time {
  font-size: 20px;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  margin-bottom: 15px;
}

.line {
  width: 20px;
  height: 1px;
  background: rgba(51, 51, 51, 1);
  margin: 0 auto;
  margin-bottom: 15px;
}

.details {
  font-size: 16px;
  font-weight: 400;
  color: rgba(159, 161, 159, 1);
}

.app {
  font-size: 16px;
  font-weight: 400;
  color: rgba(159, 161, 159, 1);
  line-height: 28px;
}

.content-two {
  width: 100%;
  height: 564px;
  position: relative;
  /* z-index: -1; */
}

.two_img {
  width: 100%;
  height: 564px;
  z-index: -2;
}

.four_img {
  width: 100%;
  height: 726px;
}

.content-two_con {
  width: 1200px;
  height: 564px;
  position: absolute;
  left: 50%;
  top: 0;
  margin-left: -600px;
}

.content-four_con_home {
  width: 1200px;
  height: 726px;
  position: absolute;
  left: 50%;
  top: 0;
  margin-left: -600px;
  z-index: 1;
}

.two_li {
  width: 100%;
  overflow: hidden;
  margin-bottom: 64px;
}

.two_li li {
  width: 200px;
  float: left;
}

.two_li li:nth-child(2),
.two_li li:nth-child(3),
.two_li li:nth-child(4) {
  margin-left: 133px;
}

.two_div {
  text-align: center;
}

.money {
  font-size: 16px;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  opacity: 0.5;
  margin-top: 13px;
  margin-bottom: 29px;
}

.xiaoes {
  font-size: 20px;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
}

.two_apply {
  width: 140px;
  height: 44px;
  border: 1px solid rgba(255, 255, 255, 0.5);
  border-radius: 4px;
  text-align: center;
  cursor: pointer;
  margin: 0 auto;
}

.two_apply p {
  line-height: 44px;
  color: rgba(255, 255, 255, 1);
}

.content-three {
  width: 100%;
  height: 986px;
}

.content-three_con {
  width: 1200px;
  margin: 0 auto;
  overflow: hidden;
}

.content-three_con img {
  width: 100%;
  height: 660px;
}

.content-four_home {
  width: 100%;
  height: 726px;
  position: relative;
}

.four_li_home {
  width: 100%;
  height: 103px;
  border-bottom: 1px solid rgba(159, 161, 159, 0.5);
  margin-bottom: 40px;
}

.four_li_home ul {
  width: 530px;
  margin: 0 auto;
}

.four_li_home ul li {
  width: 100px;
  text-align: center;
  float: left;
  cursor: pointer;
}

.four_li_home ul li:nth-child(2) {
  margin: 0 110px;
}

.four_li_home ul li p {
  margin: 14px 0 14px 0;
}

.dy {
  transition: all 0.6s;
  width: 34px;
  height: 34px;
}

.four_li_home ul li:hover .dy,
.four_li_home ul li:hover .tt,
.four_li_home ul li:hover .wx {
  transform: scale(1.5); /* 放大1.2倍 */
}

.four_li_home ul li:hover p {
  color: #337eff;
}

.four_botm ul li {
  width: 380px;
  height: 284px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 0px 20px 0px rgba(222, 234, 250, 1);
  border-radius: 4px;
  text-align: center;
  overflow: hidden;
  float: left;
}

.four_botm ul li:nth-child(2) {
  margin: 0 30px;
}

.four_div {
  width: 260px;
  margin: 39px auto;
}

.four_div img {
  width: 66px;
  width: 66px;
  margin-bottom: 39px;
}

.times {
  font-size: 20px;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  margin-bottom: 10px;
}

.content-five {
  width: 100%;
  /* height: 919px; */
  margin-bottom: 20px;
  overflow: hidden;
}

.content-five_con {
  width: 1200px;
  margin: 0 auto;
}

.five_li {
  width: 100%;
  height: 116px;
  background: linear-gradient(
    90deg,
    rgba(220, 229, 255, 0.3),
    rgba(250, 251, 255, 0.3)
  );
  /* opacity: 0.3; */
  border-radius: 10px;
  overflow: hidden;
}

.five_li ul {
  margin-top: 20px;
}

.five_li ul li {
  /* width: 96px; */
  text-align: center;
  margin-left: 72px;
  float: left;
}

.five_li ul li p {
  color: #7e90a2;
  margin-top: 10px;
}

.five_right img {
  margin: 20px 0 0 93px;
}

.five_botm {
  width: 100%;
}

.five_botm ul li {
  width: 299px;
  height: 226px;
  text-align: center;
  float: left;
  margin-top: 60px;
  position: relative;
  perspective: 800px;
  cursor: pointer;
}

.tg_app_card {
  width: 100%;
  height: 100%;
  position: absolute;
  transform-style: preserve-3d;
  transition: transform 0.6s;
  transform-origin: right center;
}

.five_botm ul li:hover .tg_app_card {
  transform: translateX(-100%) rotateY(-180deg);
}

.shows {
  width: 299px;
  height: 226px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 0px 20px 0px rgba(222, 234, 250, 1);
  border-radius: 4px;
  transform: rotateY(180deg);
}

.shows img {
  margin-top: 24px;
}

.tg_app_face {
  display: block;
  position: absolute;
  width: 100%;
  height: 100%;
  backface-visibility: hidden;
}

.five_botm ul li p {
  width: 248px;
  margin: 0 auto;
  margin-bottom: 10px;
  line-height: 25px;
  text-align: center;
}

.five_botm ul li img {
  margin-bottom: 10px;
}

.five_botm ul li:nth-child(1),
.five_botm ul li:nth-child(2),
.five_botm ul li:nth-child(3),
.five_botm ul li:nth-child(5),
.five_botm ul li:nth-child(6),
.five_botm ul li:nth-child(7) {
  border-right: 1px solid rgba(225, 230, 240, 0.5);
}

.xun_deas {
  font-size: 16px;
  font-weight: 400;
  color: rgba(159, 161, 159, 1);
}

.xun {
  font-size: 20px;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
}
.show {
  margin-top: 15px;
}

.floor {
  width: 100%;
  height: 553px;
  background: #0a1633;
  overflow: hidden;
}

.floor_1 {
  width: 1200px;
  margin: 0 auto;
  margin-bottom: 54px;
}

.floor_top {
  width: 100%;
  height: 207px;
  border-bottom: 1px solid #263758;
}

.floor_top p:nth-child(2) {
  text-align: center;
}

.shses {
  width: 140px;
  height: 44px;
}

.floor_left {
  width: 600px;
  color: #9ba5b4;
  font-size: 14px;
  float: left;
}

.floor_2 {
  width: 1200px;
  margin: 0 auto;
}

.floor_img {
  margin-bottom: 30px;
}

.floor_left_1 {
  line-height: 30px;
  margin-bottom: 30px;
}

.floor_left_2 p {
  float: left;
  line-height: 22px;
}

.floor_left_2 p img {
  margin: 0 5px;
}

.floor_right {
  width: 600px;
  float: right;
  color: #9ba5b4;
}

.floor_right_1 {
  float: left;
  margin-right: 80px;
}

.floor_right_1:nth-child(3) {
  margin-right: 0;
}

.floor_right_p {
  width: 189px;
  height: 30px;
  border-bottom: 1px solid #263758;
  font-size: 14px;
  margin-bottom: 20px;
}

.floor_right_p1 {
  width: 120px;
  height: 30px;
  border-bottom: 1px solid #263758;
  font-size: 14px;
  margin-bottom: 20px;
}

.floor_right_p2 {
  width: 120px;
  height: 30px;
  border-bottom: 1px solid #263758;
  font-size: 14px;
  margin-bottom: 20px;
}

.floor_right_ul1 {
  font-size: 12px;
  float: left;
  margin-right: 39px;
}

.floor_right_ul1 li {
  margin-bottom: 10px;
  cursor: pointer;
}

.floor_right_ul2 {
  font-size: 12px;
}

.floor_right_ul2 li {
  margin-bottom: 10px;
  cursor: pointer;
}

.floor_right_ul2 li:hover {
  color: #fff;
}

.floor_right_ul1 li:hover {
  color: #fff;
}

.products,
.productsa {
  position: relative;
}

.product {
  width: 100%;
  position: absolute;
  display: none;
  left: 0;
  z-index: 99;
}

.product_s {
  width: 558px;
  height: 192.3px;
  margin-left: -260px;
}

.products:hover .product {
  display: block;
}

.product-p {
  width: 21px;
  height: 10px;
  margin: 0 auto;
  line-height: 0;
}

.product-div {
  width: 558px;
  height: 182.3px;
  background: #fff;
  box-shadow: 0px 0px 10px 0px rgba(225, 230, 240, 1);
  border-radius: 10px;
}

.product-div_p {
  width: 212px;
  height: 182.3px;
  background: #f1f4f8;
  border-radius: 10px 0px 0px 10px;
  float: left;
}

.product-div_p img {
  margin: 20px;
}

.product-div ul {
  width: 346px;
  height: 80px;
  float: left;
}

.product-div ul li {
  margin-left: 38px;
  color: #666666;
  margin-top: 45px;
  line-height: 0;
  font-size: 14px;
  margin-right: 0;
}

.producta {
  width: 100%;
  position: absolute;
  display: none;
  left: 0;
  z-index: 99;
}

.producta_s {
  width: 450px;
  height: 192.3px;
  margin-left: -190px;
}

.productsa:hover .producta {
  display: block;
}

.producta-p {
  width: 21px;
  height: 10px;
  margin: 0 auto;
  line-height: 0;
}

.producta-div {
  width: 450px;
  height: 182.3px;
  background: #fff;
  box-shadow: 0px 0px 10px 0px rgba(225, 230, 240, 1);
  border-radius: 10px;
}

.producta-div_p {
  width: 212px;
  height: 182.3px;
  background: #f1f4f8;
  border-radius: 10px 0px 0px 10px;
  float: left;
}

.producta-div_p img {
  margin: 20px;
}

.producta-div ul {
  width: 238px;
  height: 80px;
  float: left;
  margin-top: 26px;
}

.producta-div ul li {
  margin-left: 38px;
  color: #666666;
  margin-top: 45px;
  line-height: 0;
  font-size: 14px;
  margin-right: 0;
}

.float {
  width: 240px;
  height: 300px;
  position: fixed;
  right: 0;
  bottom: 100px;
}

.float_top {
  width: 60px;
  height: 231px;
  background: rgba(23, 106, 253, 1);
  box-shadow: 0px 0px 8px 0px rgba(223, 227, 230, 0.6);
  border-radius: 4px 0px 0px 4px;
  overflow: hidden;
}

.float_top ul {
  width: 34px;
  height: 200px;
  margin: 0 auto;
  text-align: center;
  margin-top: 10px;
}

.float_top li {
  width: 34px;
  height: 46px;
  border-bottom: 1px solid #0044bc;
  color: #ffffff;
  font-size: 14px;
  margin-bottom: 10px;
  cursor: pointer;
}

.float_top li:nth-child(4) {
  border: 0;
}

.float_right {
  width: 60px;
  height: 60px;
  background: rgba(225, 231, 240, 1);
  border-radius: 4px 0px 0px 4px;
  margin-top: 16px;
}

.float_img1 {
  display: none;
}

.float_right:hover .float_img1 {
  display: block;
}

.float_right:hover .float_img {
  display: none;
}

.dingbu_img {
  position: relative;
}

.dingbu_img_1 {
  position: absolute;
  top: -70px;
}

.dingbu_img_2 {
  position: absolute;
  top: -10px;
}

.dingbu_img_3 {
  position: absolute;
  top: 140px;
}

.float_s {
  float: right;
}

.hesll {
  text-align: center;
}

.hesll p:first-child {
  font-size: 34px;
  font-family: Source Han Sans CN;
  font-weight: bold;
  color: rgba(51, 51, 51, 1);
  margin-bottom: 12px;
}

.hesll p:last-child {
  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: rgba(159, 161, 159, 1);
}

.input {
  width: 384px;
  height: 40px;
  background: rgba(255, 255, 255, 1);
  border: 1px solid rgba(215, 215, 219, 1);
  border-radius: 4px;
  margin-bottom: 20px;
}

.input input {
  border: 0;
  outline: 0;
}

.buttons {
  width: 384px;
  height: 40px;
}

.floor {
  width: 100%;
  height: 54px;
  background: rgba(241, 244, 248, 1);
  border-radius: 0px 0px 10px 10px;
  margin-top: 30px;
}

.floor p {
  text-align: center;
  line-height: 54px;
  color: #98abc1;
}

.links {
  width: 90px;
  height: 32px;
  border: 1px solid rgba(51, 125, 255, 1);
  border-radius: 4px;
}

.login {
  padding: 5px 10px;
  text-decoration: none;
  color: #666666;
}
.login1 {
  padding: 5px 10px;
  text-decoration: none;
  color: #666666;
}

.app{
  /* width: 250px; */
  font-size: 16px;
}
/*新的注册页面*/
.floords {
  width: 100%;
  height: 54px;
  background: rgba(241, 244, 248, 1);
  border-radius: 0px 0px 10px 10px;
  margin-top: 30px;
}

.floords p {
  text-align: center;
  line-height: 54px;
  color: #98abc1;
}
.input {
  width: 384px;
  height: 40px;
  background: rgba(255, 255, 255, 1);
  border: 1px solid rgba(215, 215, 219, 1);
  border-radius: 4px;
  margin-bottom: 20px;
}

.input input {
  border: 0;
  outline: 0;
}
.minaword >>>.el-input__inner{
  width: 240px;
  border: 0;
}
.linginput .minaword>>>.el-input__inner{
  width: 131px;
}
.linginput .minaword>>>.el-input-group__append{
  width: 39px;
}
.wh{
  width: 100%;
}
.minaword>>>.el-input__suffix{
  display: block !important;
}
.new_wied{
  background: #FFE5DB;
  color: #FF5614;
  padding: 3px 20px;
  border-radius: 10px;
  width: auto;
  display: inline-block;
  margin-bottom: 10px;
}
.fle-butt{
  border: none;
  color: #337EFF;
}
.demo-form-inline>>>.el-form-item__label{
  padding-left: 10px;
  color: #333333;
  text-align: left;
}
.fle_butern{
  display: flex;
  justify-content:space-between
}
</style>



// WEBPACK FOOTER //
// src/view/Home.vue